<div class="modal-body">
    <cm-step-on-behalf-list
        *ngIf="step.on_behalf_indicator"
        class="info-section"
        [onBehalfIndicator]="step.on_behalf_indicator"
    ></cm-step-on-behalf-list>
    <cm-entry-header [step]="step"></cm-entry-header>
    <cm-message-block class="message-block" *ngIf="showNotification" type="error"
        >All entries in "Draft" status are not sent for verification</cm-message-block
    >
    <cm-log-entries
        *ngIf="step.content.allowMultipleEntries || step.content.number_completed > 0"
        [entries]="step.entries"
        [allowMultipleEntries]="step.content.allowMultipleEntries"
        (clickEntry)="previewEntry($event)"
    ></cm-log-entries>
</div>
<div class="modal-footer">
    <button
        *ngIf="isPendingVerificationStatus"
        type="button"
        class="btn btn-default"
        (click)="goToPage.emit(PAGES.RESET_CONFIRM)"
    >
        RESET
    </button>
    <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
    <button
        type="button"
        *ngIf="canSubmit"
        [disabled]="step._userActionsDisabled"
        class="btn btn-primary"
        (click)="goToPage.emit(PAGES.SUBMIT_CONTENT)"
    >
        Submit {{ step._hoursFlow ? 'hours' : 'entries' }}
    </button>
    <button
        type="button"
        [disabled]="step._userActionsDisabled"
        *ngIf="step.content.number_completed >= step.content.number_required && stepEditableStatus"
        class="btn btn-primary"
        (click)="confirmStep()"
    >
        {{
            [VERIFICATION_TYPE.VERIFICATION_REQUIRED, VERIFICATION_TYPE.DOUBLE_VERIFICATION_REQUIRED].includes(
                step.verificationType
            )
                ? 'SEND FOR VERIFICATION'
                : 'COMPLETE STEP'
        }}
    </button>
</div>
